import { render, staticRenderFns } from "./WorkOtherIdsPanel.vue?vue&type=template&id=fdcdf82c"
import script from "./WorkOtherIdsPanel.vue?vue&type=script&lang=js"
export * from "./WorkOtherIdsPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkOtherIdsPanel.vue?vue&type=style&index=0&id=fdcdf82c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports